// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { FooterMobile } from './footer-mobile';

const footerStyle = {
  backgroundColor: '#FFFFFF',
  padding: '30px 80px',
  textAlign: 'left',
  fontWeight: '300',
};

const rowStyle = {
  display: 'flex',
  // justifyContent: 'space-between',
  alignItems: 'top',
};

const logoRowStyle = {
  ...rowStyle,
  alignItems: 'end',
};

const socialsRowStyle = {
  ...rowStyle,
  marginLeft: '-.35rem',
  alignItems: 'baseline',
  marginTop: '.5rem',
};

const columnStyle = {
  flex: '1',
  padding: '5px',
  boxSizing: 'border-box',
  maxWidth: 'fit-content',
};

const logoColumn1Style = {
  ...columnStyle,
  paddingBottom: '.75rem'
};

const logoColumn3Style = {
  ...columnStyle,
  paddingBottom: '.8rem',
  fontWeight: '500',
};

const footerLeftColStyle = {
  flex: '3',
  paddingRight: '2rem',
};

const footerRightColStyle = {
  alignItems: 'left',
  flex: '1',
  paddingLeft: '2rem',
};

const footerTextStyle = {
  color: '#2D2D2D',
  fontSize: '11px',
  padding: '20px 0 20px 0'
};

const footerDivStyle = {
  paddingTop: '1rem',
  fontSize: '11px',
};

const footerUlStyle = {
  color: '#89364D',
  fontSize: '11px',
};

const horizLineStyle = {
  borderBottom: '3px #CCCCCC solid',
  width: '30px',
  height: '1px',
};

const verticLineStyle = {
  borderLeft: '3px #CCCCCC solid',
  width: '1px',
  marginTop: '.75rem',
};

function getCurrentDimension() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

interface Props {}

export const Footer: React.FC<Props> = () => {
  const [screenWidth, setScreenWidth] = useState('wide');
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  // const [styles, setStyles] = useState(initialStyles);
  const [isMobileApp, setIsMobileApp] = useState(false);

  useEffect(() => {
    setIsMobileApp(window.isMobileApp === true);
  });

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener('resize', updateDimension);

    setScreenWidth((screenSize.width < 682) ? 'narrow' : 'wide');
    return (() => {
      window.removeEventListener('resize', updateDimension);
    });
  }, [screenSize]);

  useEffect(() => {
    // if (screenWidth === 'narrow') {
    //   setStyles(
    //     { ...styles,
    //       logoLiStyle: {
    //         ...styles.logoLiStyle,
    //         marginRight: '0',
    //       }
    //     }
    //   );
    // } else if (screenWidth === 'wide') {
    //   setStyles(
    //     { ...styles,
    //       navBarStyle: initialNavBarStyle,
    //       logoLiStyle: initialLogoLiStyle,
    //     }
    //   );
    // }
  }, [screenWidth]);

  return (
    <>
      {(isMobileApp || screenWidth === 'narrow') && <FooterMobile />}
      {(!isMobileApp && screenWidth !== 'narrow') && (
      <footer style={footerStyle}>
        <div style={rowStyle}>
          <div style={footerLeftColStyle}>
            <div style={logoRowStyle}>
              <div style={logoColumn1Style}>
                <svg width="34" height="38" viewBox="0 0 34 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.9124 12.5525V11.7169C15.072 10.6242 11.7103 8.56722 7.24956 8.56725C2.78885 8.56727 -0.18499 13.3238 0.00895431 17.1805C0.202898 21.0373 1.17262 25.151 6.02122 30.1647C9.90009 34.1757 13.5204 36.6568 15.072 37.5567C15.2659 37.6424 15.7055 37.7624 15.9124 37.5567C16.1193 37.351 15.9986 37.1282 15.9124 37.0425C15.503 36.6354 13.5721 34.5871 9.12435 29.6505C4.67657 24.7139 3.90942 20.5658 4.08181 19.1089C3.90942 18.4661 4.00424 16.6277 5.76266 14.4165C7.52109 12.2054 12.8739 12.6382 15.3306 13.131C15.5245 13.1524 15.9124 13.0667 15.9124 12.5525Z" fill="#7B3A4A" />
                  <path d="M17.2566 12.5525V11.7169C18.0929 10.6242 21.4379 8.56722 25.8764 8.56725C30.3149 8.56727 33.2739 13.3238 33.081 17.1805C32.888 21.0373 31.9231 25.151 27.0986 30.1647C23.239 34.1757 19.6367 36.6568 18.0929 37.5567C17.8999 37.6424 17.4625 37.7624 17.2566 37.5567C17.0508 37.351 17.1709 37.1282 17.2566 37.0425C17.664 36.6354 19.5853 34.5871 24.0109 29.6505C28.4366 24.7139 29.1999 20.5658 29.0284 19.1089C29.1999 18.4661 29.1055 16.6277 27.3559 14.4165C25.6062 12.2054 20.28 12.6382 17.8356 13.131C17.6426 13.1524 17.2566 13.0667 17.2566 12.5525Z" fill="#7B3A4A" />
                  <path d="M11.2884 2.26926L12.6568 1.23329C13.0641 1.67728 14.0839 2.86124 14.9049 4.0452C15.726 5.22916 16.2896 7.72864 16.4688 8.83038C16.5828 7.66286 17.153 4.86411 18.5214 3.00924C19.8898 1.15436 21.7958 0.230215 22.5778 0C23.052 1.29196 23.052 1.90394 22.9199 3.00924C22.8313 3.75036 23.3597 4.09453 20.4274 7.00511C18.0816 9.33356 16.8109 10.0143 16.4688 10.0637H15.8335C15.4914 8.86327 14.6215 6.04807 13.8786 4.39052C13.1358 2.73298 11.8423 2.2857 11.2884 2.26926Z" fill="#679A41" />
                </svg>
              </div>
              <div style={columnStyle}>
                <h2 className="font-inter font-bold text-[2rem] text-red">
                  HeartMap
                </h2>
              </div>
              <div style={logoColumn3Style}>
                <h3 className="font-inter text-[1rem] text-black">
                  by Boston Heart Diagnostics
                </h3>
              </div>
            </div>
            <div style={footerTextStyle} className="font-roboto">
              Boston Heart Diagnostics is transforming the treatment of cardiovascular
              disease and related diseases with novel diagnostics, reports, and a
              personalized, scientifically designed nutrition and lifestyle program
              that have the power to change the way healthcare providers and patients
              communicate about heart health.
            </div>
            <div style={horizLineStyle} />
            <div style={footerDivStyle}>
              <ul style={footerUlStyle}>
                <li className="font-roboto">
                  <a href="https://bostonheartdiagnostics.com/all-rights-reserved/" target="_blank" rel="noreferrer">ALL RIGHTS RESERVED</a>
                </li>
                <li className="font-roboto">
                  <a href="https://bostonheartdiagnostics.com/terms-and-conditions/" target="_blank" rel="noreferrer">TERMS AND CONDITIONS</a>
                </li>
                <li className="font-roboto">
                  <a href="https://bostonheartdiagnostics.com/heartmap-patient-privacy/" target="_blank" rel="noreferrer">PATIENT PRIVACY</a>
                </li>
                <li className="font-roboto">
                  <a href="https://bostonheartdiagnostics.com/wp-content/uploads/2020/08/BHD-CCPA-Privacy-Notice-for-California-Residents-July-2020.pdf" target="_blank" rel="noreferrer">PRIVACY NOTICE FOR CALIFORNIA RESIDENTS</a>
                </li>
              </ul>
            </div>
            <div style={footerDivStyle} className="font-roboto">
              © Boston Heart Diagnostics Corporation
            </div>
          </div>
          <div style={verticLineStyle} />
          <div style={footerRightColStyle}>
            <div style={socialsRowStyle}>
              <div style={columnStyle}>
                <a href="https://www.facebook.com/Bostonheartdx" target="_blank" rel="noreferrer">
                  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_88_169)">
                      <path d="M8.22307 0.107177V2.46432H6.82129C6.30938 2.46432 5.96415 2.57146 5.78557 2.78575C5.607 3.00003 5.51772 3.32146 5.51772 3.75003V5.43753H8.13379L7.78557 8.08039H5.51772V14.8572H2.78557V8.08039H0.508789V5.43753H2.78557V3.49111C2.78557 2.38396 3.0951 1.52533 3.71415 0.915213C4.33319 0.305094 5.1576 3.43323e-05 6.18736 3.43323e-05C7.06236 3.43323e-05 7.74093 0.0357485 8.22307 0.107177Z" fill="#89364D" />
                    </g>
                    <defs>
                      <clipPath id="clip0_88_169">
                        <rect width="9.16" height="16" fill="white" transform="matrix(1 0 0 -1 0.5 16)" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
              <div style={columnStyle}>
                <a href="https://twitter.com/BostonHeartDX" target="_blank" rel="noreferrer">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.0128 1.64293C14.614 2.22626 14.1319 2.72328 13.5664 3.134C13.5724 3.21733 13.5753 3.34233 13.5753 3.509C13.5753 4.28281 13.4622 5.05513 13.236 5.82596C13.0099 6.5968 12.6661 7.33638 12.2048 8.04471C11.7435 8.75305 11.1944 9.37953 10.5575 9.92418C9.92057 10.4688 9.15272 10.9033 8.25391 11.2277C7.3551 11.5522 6.39379 11.7144 5.36998 11.7144C3.75688 11.7144 2.28069 11.2828 0.941406 10.4197C1.14974 10.4435 1.38188 10.4554 1.63783 10.4554C2.97712 10.4554 4.17057 10.0447 5.21819 9.22328C4.59319 9.21138 4.03367 9.01941 3.53962 8.64739C3.04557 8.27537 2.70629 7.80066 2.52176 7.22328C2.71819 7.25305 2.89974 7.26793 3.06641 7.26793C3.32236 7.26793 3.57534 7.23519 3.82534 7.16971C3.15867 7.03281 2.60658 6.70096 2.16908 6.17418C1.73158 5.64739 1.51283 5.03578 1.51283 4.33935V4.30364C1.9176 4.52983 2.35212 4.65185 2.81641 4.66971C2.42355 4.40781 2.11105 4.06555 1.87891 3.64293C1.64676 3.22031 1.53069 2.76197 1.53069 2.26793C1.53069 1.74412 1.66164 1.259 1.92355 0.81257C2.64379 1.69947 3.52028 2.4093 4.55301 2.94203C5.58575 3.47477 6.69141 3.7709 7.86998 3.83043C7.82236 3.60424 7.79855 3.384 7.79855 3.16971C7.79855 2.37209 8.0798 1.69203 8.6423 1.12953C9.2048 0.567034 9.88486 0.285784 10.6825 0.285784C11.5158 0.285784 12.2182 0.589355 12.7896 1.1965C13.4384 1.0715 14.0485 0.839355 14.62 0.50007C14.3997 1.18459 13.9771 1.71436 13.3521 2.08936C13.9057 2.02983 14.4593 1.88102 15.0128 1.64293Z" fill="#89364D" />
                  </svg>
                </a>
              </div>
              <div style={columnStyle}>
                <a
                  href="https://www.linkedin.com/company/boston-heart-diagnostics"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.49888 4.58025V13.4285H0.552455V4.58025H3.49888ZM3.68638 1.84811C3.69234 2.28263 3.54204 2.64573 3.23549 2.9374C2.92894 3.22906 2.52567 3.3749 2.02567 3.3749H2.00781C1.51972 3.3749 1.12686 3.22906 0.829241 2.9374C0.531622 2.64573 0.382812 2.28263 0.382812 1.84811C0.382812 1.40763 0.536086 1.04305 0.842634 0.754359C1.14918 0.465669 1.54948 0.321323 2.04353 0.321323C2.53757 0.321323 2.93341 0.465669 3.23103 0.754359C3.52865 1.04305 3.68043 1.40763 3.68638 1.84811ZM14.0971 8.35704V13.4285H11.1596V8.69632C11.1596 8.07132 11.0391 7.58174 10.798 7.22757C10.5569 6.87341 10.1804 6.69632 9.66853 6.69632C9.29353 6.69632 8.97954 6.799 8.72656 7.00436C8.47359 7.20972 8.2846 7.46418 8.1596 7.76775C8.09412 7.94632 8.06138 8.1874 8.06138 8.49097V13.4285H5.12388C5.13579 11.0535 5.14174 9.12787 5.14174 7.65168C5.14174 6.17549 5.13876 5.29454 5.13281 5.00882L5.12388 4.58025H8.06138V5.86597H8.04353C8.16257 5.67549 8.2846 5.50882 8.4096 5.36597C8.5346 5.22311 8.70275 5.06835 8.91406 4.90168C9.12537 4.73501 9.3843 4.60555 9.69085 4.51329C9.9974 4.42103 10.3382 4.3749 10.7132 4.3749C11.731 4.3749 12.5495 4.71269 13.1685 5.38829C13.7876 6.06388 14.0971 7.05347 14.0971 8.35704Z" fill="#89364D" />
                  </svg>
                </a>
              </div>
              <div style={columnStyle}>
                <a href="https://www.instagram.com/bostonheartdx/" target="_blank" rel="noreferrer">
                  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.28572 8.61611C9.28572 8.61611 9.39732 8.5045 9.62054 8.28128C9.84375 8.05807 9.95536 7.63099 9.95536 7.00003C9.95536 6.36908 9.73214 5.83039 9.28572 5.38396C8.83929 4.93753 8.3006 4.71432 7.66964 4.71432C7.03869 4.71432 6.5 4.93753 6.05357 5.38396C5.60714 5.83039 5.38393 6.36908 5.38393 7.00003C5.38393 7.63099 5.60714 8.16968 6.05357 8.61611C6.5 9.06253 7.03869 9.28575 7.66964 9.28575C8.3006 9.28575 8.83929 9.06253 9.28572 8.61611ZM10.1607 4.50896C10.1607 4.50896 10.3318 4.68009 10.6741 5.02236C11.0164 5.36462 11.1875 6.02384 11.1875 7.00003C11.1875 7.97622 10.8452 8.80658 10.1607 9.49111C9.47619 10.1756 8.64583 10.5179 7.66964 10.5179C6.69345 10.5179 5.8631 10.1756 5.17857 9.49111C4.49405 8.80658 4.15179 7.97622 4.15179 7.00003C4.15179 6.02384 4.49405 5.19349 5.17857 4.50896C5.8631 3.82444 6.69345 3.48218 7.66964 3.48218C8.64583 3.48218 9.47619 3.82444 10.1607 4.50896ZM11.9107 2.75896C11.9107 2.75896 11.9509 2.79914 12.0313 2.8795C12.1116 2.95986 12.1518 3.11313 12.1518 3.33932C12.1518 3.56551 12.0714 3.75896 11.9107 3.91968C11.75 4.08039 11.5565 4.16075 11.3304 4.16075C11.1042 4.16075 10.9107 4.08039 10.75 3.91968C10.5893 3.75896 10.5089 3.56551 10.5089 3.33932C10.5089 3.11313 10.5893 2.91968 10.75 2.75896C10.9107 2.59825 11.1042 2.51789 11.3304 2.51789C11.5565 2.51789 11.75 2.59825 11.9107 2.75896ZM8.35268 1.37057C8.35268 1.37057 8.24926 1.37131 8.04241 1.3728C7.83557 1.37429 7.71131 1.37503 7.66964 1.37503C7.62798 1.37503 7.4003 1.37355 6.98661 1.37057C6.57292 1.36759 6.25893 1.36759 6.04464 1.37057C5.83036 1.37355 5.54316 1.38247 5.18304 1.39736C4.82292 1.41224 4.51637 1.442 4.26339 1.48664C4.01042 1.53128 3.79762 1.58634 3.625 1.65182C3.32738 1.77087 3.06548 1.94349 2.83929 2.16968C2.6131 2.39587 2.44048 2.65777 2.32143 2.95539C2.25595 3.12801 2.20089 3.34081 2.15625 3.59378C2.11161 3.84676 2.08185 4.15331 2.06696 4.51343C2.05208 4.87355 2.04315 5.16075 2.04018 5.37503C2.0372 5.58932 2.0372 5.90331 2.04018 6.317C2.04315 6.73069 2.04464 6.95837 2.04464 7.00003C2.04464 7.0417 2.04315 7.26938 2.04018 7.68307C2.0372 8.09676 2.0372 8.41075 2.04018 8.62503C2.04315 8.83932 2.05208 9.12652 2.06696 9.48664C2.08185 9.84676 2.11161 10.1533 2.15625 10.4063C2.20089 10.6593 2.25595 10.8721 2.32143 11.0447C2.44048 11.3423 2.6131 11.6042 2.83929 11.8304C3.06548 12.0566 3.32738 12.2292 3.625 12.3482C3.79762 12.4137 4.01042 12.4688 4.26339 12.5134C4.51637 12.5581 4.82292 12.5878 5.18304 12.6027C5.54316 12.6176 5.83036 12.6265 6.04464 12.6295C6.25893 12.6325 6.57292 12.6325 6.98661 12.6295C7.4003 12.6265 7.62798 12.625 7.66964 12.625C7.71131 12.625 7.93899 12.6265 8.35268 12.6295C8.76637 12.6325 9.08036 12.6325 9.29464 12.6295C9.50893 12.6265 9.79613 12.6176 10.1562 12.6027C10.5164 12.5878 10.8229 12.5581 11.0759 12.5134C11.3289 12.4688 11.5417 12.4137 11.7143 12.3482C12.0119 12.2292 12.2738 12.0566 12.5 11.8304C12.7262 11.6042 12.8988 11.3423 13.0179 11.0447C13.0833 10.8721 13.1384 10.6593 13.183 10.4063C13.2277 10.1533 13.2574 9.84676 13.2723 9.48664C13.2872 9.12652 13.2961 8.83932 13.2991 8.62503C13.3021 8.41075 13.3021 8.09676 13.2991 7.68307C13.2961 7.26938 13.2946 7.0417 13.2946 7.00003C13.2946 6.95837 13.2961 6.73069 13.2991 6.317C13.3021 5.90331 13.3021 5.58932 13.2991 5.37503C13.2961 5.16075 13.2872 4.87355 13.2723 4.51343C13.2574 4.15331 13.2277 3.84676 13.183 3.59378C13.1384 3.34081 13.0833 3.12801 13.0179 2.95539C12.8988 2.65777 12.7262 2.39587 12.5 2.16968C12.2738 1.94349 12.0119 1.77087 11.7143 1.65182C11.5417 1.58634 11.3289 1.53128 11.0759 1.48664C10.8229 1.442 10.5164 1.41224 10.1562 1.39736C9.79613 1.38247 9.50893 1.37355 9.29464 1.37057C9.08036 1.36759 8.76637 1.36759 8.35268 1.37057ZM14.4821 4.16968C14.5119 4.69349 14.5268 5.63694 14.5268 7.00003C14.5268 8.36313 14.5119 9.30658 14.4821 9.83039C14.4226 11.0685 14.0536 12.0268 13.375 12.7054C12.6964 13.384 11.7381 13.753 10.5 13.8125C9.97619 13.8423 9.03274 13.8572 7.66964 13.8572C6.30655 13.8572 5.3631 13.8423 4.83929 13.8125C3.60119 13.753 2.64286 13.384 1.96429 12.7054C1.28571 12.0268 0.916667 11.0685 0.857143 9.83039C0.827381 9.30658 0.8125 8.36313 0.8125 7.00003C0.8125 5.63694 0.827381 4.69349 0.857143 4.16968C0.916667 2.93158 1.28571 1.97325 1.96429 1.29468C2.64286 0.616106 3.60119 0.247058 4.83929 0.187534C5.3631 0.157772 6.30655 0.142891 7.66964 0.142891C9.03274 0.142891 9.97619 0.157772 10.5 0.187534C11.7381 0.247058 12.6964 0.616106 13.375 1.29468C14.0536 1.97325 14.4226 2.93158 14.4821 4.16968Z" fill="#89364D" />
                  </svg>
                </a>
              </div>
            </div>
            <div className="text-red font-robotoCondensed text-[.9rem] font-bold mt-2">
              Boston Heart Diagnostics
            </div>
            <div className="font-roboto text-[.7rem] font-light">
              200 Crossing Boulevard
              <br />
              Framingham, MA 01702
            </div>
          </div>
        </div>
      </footer>
      )}
    </>
  );
};
